import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionCommercePermissions extends BaseScenesPermissions {}

export default EmissionCommercePermissions
